/* MONOM, Discovery Set in regalo con un profumo.

   Come funziona, in breve: il kit regalo e' un prodotto vero a listino, non un
   prodotto a zero euro (un prodotto a zero euro resta raggiungibile col link
   diretto e chiunque se lo porta via gratis). Qui lo si mette nel carrello come
   riga normale; a portarlo a zero in cassa e' uno sconto automatico Compra X
   Prendi Y, lato Shopify.

   Il kit regalato e' un prodotto SEPARATO da quello venduto, con SKU diverso:
   i tre flussi "Order paid" di MONOM danno il tag del rimborso Discovery a chi
   compra un kit, e se il regalo fosse la stessa variante il cliente si
   prenderebbe anche il rimborso. Con una variante diversa i flussi non lo vedono.

   Un regalo per ordine, il migliore: col 30 ml il kit completo, altrimenti,
   col 10 ml, quello da cinque. Non si sommano.
*/
(function () {
  var DATI = null;
  try {
    var tag = document.getElementById('monom-regalo-dati');
    if (tag) DATI = JSON.parse(tag.textContent);
  } catch (e) { /* senza dati lo script non fa niente */ }
  if (!DATI || !DATI.attivo) return;

  var fetchVero = window.fetch.bind(window);
  var inCorso = false;

  function chiama(url, corpo) {
    return fetchVero(url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json',
                'X-Monom-Regalo': '1'},
      body: JSON.stringify(corpo)
    });
  }

  /* Un profumo da indossare si riconosce dal nome della variante: su questi
     prodotti e' sempre "10ml Profumo Puro" o "30ml Profumo Puro". Nessun altro
     prodotto del catalogo usa quei nomi (i diffusori sono "500ml", la linea
     corpo "Vanille" e simili). Cosi' il tema non deve passare al JS l'elenco
     delle varianti, che costava un giro su tutti i prodotti a ogni pagina. */
  function qualeRegalo(carrello) {
    var ha10 = false, ha30 = false;
    for (var i = 0; i < carrello.items.length; i++) {
      var nome = (carrello.items[i].variant_title || '').toLowerCase().replace(/\s+/g, '');
      if (nome.indexOf('30mlprofumopuro') !== -1) ha30 = true;
      if (nome.indexOf('10mlprofumopuro') !== -1) ha10 = true;
    }
    if (ha30) return DATI.regaloGrande;
    if (ha10) return DATI.regaloPiccolo;
    return null;
  }

  /* Le chiamate al carrello vanno fatte UNA ALLA VOLTA. Lanciate insieme,
     Shopify ne serve una e scarta le altre: togliendo un regalo e aggiungendo
     l'altro nello stesso istante si finiva con nessuno dei due. Dopo aver
     toccato il carrello si rilegge e si ricontrolla, al massimo tre giri. */
  function sincronizza() {
    if (inCorso) return Promise.resolve(false);
    inCorso = true;
    var cambiato = false;

    function passo(giro) {
      if (giro > 3) return Promise.resolve();
      return fetchVero('/cart.js', {headers: {'X-Monom-Regalo': '1'}})
        .then(function (r) { return r.json(); })
        .then(function (carrello) {
          var voluto = qualeRegalo(carrello);
          /* Le righe del regalo si toccano per chiave, non per variante. Se due
             aggiunte si sovrappongono (si cambia pagina mentre la prima e' in
             corso) Shopify crea due righe della stessa variante: cambiando per
             variante si toccava solo la prima, e la seconda restava a 45 euro.
             Si tiene una riga sola, quella gia' scontata se c'e'. */
          var righe = carrello.items.filter(function (v) {
            var id = String(v.variant_id);
            return id === DATI.regaloPiccolo || id === DATI.regaloGrande;
          }).sort(function (a, b) { return a.final_line_price - b.final_line_price; });
          var tenuta = null, daTogliere = null;
          righe.forEach(function (v) {
            if (!tenuta && String(v.variant_id) === voluto) tenuta = v;
            else if (!daTogliere) daTogliere = v;
          });
          if (daTogliere) {
            cambiato = true;
            return chiama('/cart/change.js', {id: daTogliere.key, quantity: 0})
              .then(function () { return passo(giro + 1); });
          }
          if (tenuta && tenuta.quantity !== 1) {
            cambiato = true;
            return chiama('/cart/change.js', {id: tenuta.key, quantity: 1})
              .then(function () { return passo(giro + 1); });
          }
          if (voluto && !tenuta) {
            cambiato = true;
            /* change.js non crea righe nuove: per aggiungere serve add.js */
            return chiama('/cart/add.js', {items: [{id: Number(voluto), quantity: 1}]})
              .then(function () { return passo(giro + 1); });
          }
          return null;
        });
    }

    return passo(1)
      .then(function () { inCorso = false; return cambiato; })
      .catch(function (e) { inCorso = false; console.error('MONOM regalo:', e); return cambiato; });
  }

  function aggiornaCassetto() {
    /* Sulla pagina carrello c'e' anche il cassetto: ridisegnando solo quello la
       pagina restava con le righe vecchie (si vedeva il regalo due volte). */
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var c = document.querySelector('cart-drawer');
    if (c && typeof c.handleCartRender === 'function') c.handleCartRender();
    else if (/\/cart/.test(location.pathname)) location.reload();
  }

  /* Ogni volta che il tema tocca il carrello, si ricontrolla il regalo. Si
     riconoscono le nostre chiamate dall'intestazione, per non rincorrersi. */
  window.fetch = function (risorsa, opzioni) {
    var url = typeof risorsa === 'string' ? risorsa : (risorsa && risorsa.url) || '';
    var nostra = opzioni && opzioni.headers &&
      (opzioni.headers['X-Monom-Regalo'] || (opzioni.headers.get && opzioni.headers.get('X-Monom-Regalo')));
    var promessa = fetchVero.apply(null, arguments);
    if (!nostra && /\/cart\/(add|change|update|clear)/.test(url)) {
      promessa.then(function () {
        setTimeout(function () {
          sincronizza().then(function (cambiato) { if (cambiato) aggiornaCassetto(); });
        }, 120);
      }).catch(function () {});
    }
    return promessa;
  };

  /* Marca la riga del regalo dentro il cassetto, per nascondere i comandi di
     quantita' e rimozione: e' un regalo, non si tocca. La riga si riconosce dal
     link al prodotto; il contenitore e' `.cart-drawer__product_card` sul
     cassetto e `.cart-item` o la riga di tabella sulla pagina carrello. */
  function segnaRighe() {
    var vecchie = document.querySelectorAll('[data-monom-regalo]');
    for (var i = 0; i < vecchie.length; i++) vecchie[i].removeAttribute('data-monom-regalo');
    var link = document.querySelectorAll('a[href*="omaggio-discovery-kit"]');
    for (var j = 0; j < link.length; j++) {
      var riga = link[j].closest('.cart-drawer__product_card, .cart-item, tr, li');
      if (riga) riga.setAttribute('data-monom-regalo', '1');
    }
  }

  function avvia() {
    sincronizza().then(function (cambiato) { if (cambiato) aggiornaCassetto(); });
    segnaRighe();
    new MutationObserver(segnaRighe).observe(document.documentElement,
      {childList: true, subtree: true});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
